import React, { useEffect } from "react";
import "../App.css"; // Import the CSS file for styles
import 'animate.css';
import WOW from 'wowjs';

function GoogleMap() {
  useEffect(() => {
    // Initialize WOW.js for scroll animations
    new WOW.WOW({
      live: false,
    }).init();
  }, []);

  return (
    <div 
      className="google-map-container wow animate__animated animate__fadeInRight" 
      data-wow-duration="1.5s"
    >
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d60375.14469978786!2d73.96162316805253!3d18.95587652350128!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bdd2dfea4343f03%3A0x1028135690396e04!2sAwasari%20Bk.%2C%20Maharashtra%2C%20India!5e0!3m2!1sen!2sus!4v1736999765216!5m2!1sen!2sus"
        width="600"
        height="450"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        title="Google Map"
      ></iframe>
    </div>
  );
}

export default GoogleMap;
